document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.navigation')
  if (!header) return

  const sections = document.querySelectorAll('[data-header-theme]')
  const defaultTheme = 'dark'

  const updateHeaderTheme = () => {
    let activeTheme = defaultTheme
    // Check intersection with the top of viewport
    const checkY = 20

    // Find the section that covers the top area
    // Iterate in reverse to find the topmost one in stacking context if overlaps occur,
    // but usually document order is fine for sections.
    for (const section of sections) {
      const rect = section.getBoundingClientRect()
      if (rect.top <= checkY && rect.bottom >= checkY) {
        activeTheme = section.dataset.headerTheme
        break // Found the section at the top
      }
    }

    // Apply theme
    if (header.dataset.headerTheme !== activeTheme) {
      header.setAttribute('data-header-theme', activeTheme)
    }
  }

  window.addEventListener('scroll', updateHeaderTheme, { passive: true })
  window.addEventListener('resize', updateHeaderTheme)

  // Initial check
  updateHeaderTheme()
})
